import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from 'src/app/services/common/api-service.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-merchant-advertisement',
  templateUrl: './merchant-advertisement.component.html',
  styleUrls: ['./merchant-advertisement.component.scss']
})
export class MerchantAdvertisementComponent implements OnInit {

  merchantData: any;
  currentTier: string = 'STANDARD';
  loading: boolean = true;
  savingAd: boolean = false;

  adData = {
    isActive: false,
    title: '',
    text: '',
    code: '',
    activatedAt: null,
    activationsThisMonth: 0
  };

  constructor(
    private apiService: ApiServiceService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const merchantId = localStorage.getItem('merchantId');
    if (merchantId) {
      this.apiService.getMerchantProfile(merchantId).subscribe({
        next: (res: any) => {
          this.merchantData = res.data;
          this.currentTier = this.merchantData.subscriptionTier || 'STANDARD';
          
          if (this.merchantData.advertisement) {
            this.adData = { 
              ...this.adData, 
              ...this.merchantData.advertisement 
            };
          }
          this.loading = false;
        },
        error: (err) => {
          console.error("Failed to load merchant profile", err);
          this.loading = false;
        }
      });
    } else {
      this.loading = false;
    }
  }

  saveAdvertisement() {
    if (!this.merchantData?._id) return;
    
    // Check quota before enabling
    if (this.adData.isActive && !this.merchantData.advertisement?.isActive) {
      if (this.adData.activationsThisMonth >= 7) {
        Swal.fire('Limit Reached', 'You have reached your monthly limit of 7 ad activations.', 'warning');
        this.adData.isActive = false; // Revert toggle
        return;
      }
    }

    this.savingAd = true;
    this.apiService.updateAdvertisement(this.merchantData._id, this.adData).subscribe({
      next: (res: any) => {
        this.savingAd = false;
        Swal.fire('Success', 'Advertisement preferences saved!', 'success');
        if (res.data && res.data.advertisement) {
          this.merchantData.advertisement = res.data.advertisement;
          this.adData = { ...this.adData, ...res.data.advertisement };
        }
      },
      error: (err) => {
        this.savingAd = false;
        Swal.fire('Error', err.error?.message || 'Failed to save advertisement', 'error');
        // Revert toggle on error
        if (this.merchantData.advertisement) {
          this.adData.isActive = this.merchantData.advertisement.isActive;
        }
      }
    });
  }

  get remainingCredits(): number {
    return Math.max(0, 7 - (this.adData.activationsThisMonth || 0));
  }

  get hoursLeft(): number {
    if (!this.adData.isActive || !this.adData.activatedAt) return 0;
    const activatedTime = new Date(this.adData.activatedAt).getTime();
    const now = new Date().getTime();
    const diffHours = 24 - (now - activatedTime) / (1000 * 60 * 60);
    return Math.max(0, Math.floor(diffHours));
  }
}
